import "./ClientAudienceFilter.css";
import { MESSAGE_TYPE_LABELS } from "../../../models/MessageModels";

export type AudienceMode = "all" | "pending" | "due" | "appointments";

export const AUDIENCE_LABELS: Record<AudienceMode, string> = {
  all: "All clients",
  pending: "Follow-ups pending",
  due: "Follow-ups due",
  appointments: "Appointments",
};

export const AUDIENCE_COUNT_HINT: Partial<Record<AudienceMode, string>> = {
  pending: "status = Pending",
  due: "pending follow-ups due now or earlier",
  appointments: "clients with appointments",
};

interface ClientAudienceFilterProps {
  mode: AudienceMode;
  onModeChange: (mode: AudienceMode) => void;
  search: string;
  onSearchChange: (value: string) => void;
  onSearchSubmit: () => void;
  messageType: number;
  onMessageTypeChange: (value: number) => void;
  counts?: Partial<Record<AudienceMode, number>>;
  modes?: AudienceMode[];
  disabled?: boolean;
}

const ClientAudienceFilter = ({
  mode,
  onModeChange,
  search,
  onSearchChange,
  onSearchSubmit,
  messageType,
  onMessageTypeChange,
  counts,
  modes = Object.keys(AUDIENCE_LABELS) as AudienceMode[],
  disabled = false,
}: ClientAudienceFilterProps) => (
  <div className="msg-filter">
    <div className="msg-filter__search">
      <span className="msg-filter__label">Search clients</span>
      <div className="msg-filter__search-row">
        <input
          type="search"
          placeholder="Name or phone…"
          value={search}
          disabled={disabled}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              onSearchSubmit();
            }
          }}
        />
        <button
          type="button"
          className="msg-filter__search-btn"
          disabled={disabled}
          onClick={onSearchSubmit}
        >
          Search
        </button>
      </div>
    </div>

    <div className="msg-filter__group">
      <span className="msg-filter__label">Audience</span>
      <div className="msg-filter__presets" role="group" aria-label="Audience presets">
        {modes.map((key) => (
          <button
            key={key}
            type="button"
            className={`msg-filter__preset ${
              mode === key ? "msg-filter__preset--active" : ""
            }`}
            disabled={disabled}
            aria-pressed={mode === key}
            title={AUDIENCE_COUNT_HINT[key]}
            onClick={() => onModeChange(key)}
          >
            {AUDIENCE_LABELS[key]}
            {counts?.[key] !== undefined && (
              <span className="msg-filter__count">{counts[key]}</span>
            )}
          </button>
        ))}
      </div>
    </div>

    <label className="msg-filter__group">
      <span className="msg-filter__label">Message type</span>
      <select
        value={String(messageType)}
        disabled={disabled}
        onChange={(e) => onMessageTypeChange(Number(e.target.value))}
      >
        {Object.entries(MESSAGE_TYPE_LABELS).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
    </label>
  </div>
);

export default ClientAudienceFilter;
